import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '@/lib/api';

const CategoriesContext = createContext([]);

/**
 * Module-level cache — survives React tree remounts.
 * Single in-flight promise deduplicates concurrent mounts.
 */
let _cache = null;        // resolved categories array once fetched
let _promise = null;      // in-flight fetch promise

function fetchOnce() {
    if (_cache !== null) return Promise.resolve(_cache);
    if (_promise !== null) return _promise;
    _promise = api.get('/categories')
        .then(r => { _cache = r.data || []; return _cache; })
        .catch(() => { _promise = null; return []; });
    return _promise;
}

/** Call this from tests or hot-reload to force a fresh fetch. */
export function invalidateCategoriesCache() {
    _cache = null;
    _promise = null;
}

export const CategoriesProvider = ({ children }) => {
    const [cats, setCats] = useState(_cache || []);

    useEffect(() => {
        if (_cache !== null) { setCats(_cache); return; }
        let cancelled = false;
        fetchOnce().then(data => { if (!cancelled) setCats(data); });
        return () => { cancelled = true; };
    }, []);

    return (
        <CategoriesContext.Provider value={cats}>
            {children}
        </CategoriesContext.Provider>
    );
};

export const useCategories = () => useContext(CategoriesContext);
